// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'

import {
  getAllVisiblePathIds,
  updateInterferenceAnalysisState,
} from 'redux/modules/interferenceAnalysis'

// toggles all visible paths as highlighted.
// if they're already all highlighted, it removes them
// else it highlights everything.

const toggleAllPathHighlight = () => (dispatch, getState) => {
  const prevHighlighted = getState().interferenceAnalysis.get('highlightedPathIds')
  const visiblePathIds = dispatch(getAllVisiblePathIds())

  const highlightedPathIds = (
    visiblePathIds.size === prevHighlighted.size
      ? fromJS([])
      : visiblePathIds
  )

  dispatch(updateInterferenceAnalysisState({ highlightedPathIds }))
}

export default toggleAllPathHighlight
